/* eslint-disable */
import Vue from 'vue';

import * as quizData from './quizData.json';
//import loadImage from 'image-promise';

export const eventBus = new Vue({
  data() {
    return {
      currentQuestion: 0,
      numQuestions: 7,
    };
  },
  methods: {
    beginQuiz() {
      this.dateSwap();
    },
    dateSwap: function() {
      var d0 = new Date('12/26/2019 00:00:00').getTime();
      var d1 = new Date('12/27/2019 00:00:00').getTime();
      var d2 = new Date('12/28/2019 00:00:00').getTime();
      var d3 = new Date('12/29/2019 00:00:00').getTime();
      var d4 = new Date('12/30/2019 00:00:00').getTime();
      var d5 = new Date('12/31/2019 00:00:00').getTime();
      var d6 = new Date('01/01/2020 00:00:00').getTime();

      var now = new Date().getTime();

      if (now >= d6){
        this.$emit('beginQuizQuestions', quizData.questions[6]);
      } 
      else if (now >= d5 && now < d6){
        this.$emit('beginQuizQuestions', quizData.questions[5]);
      }
      else if (now >= d4 && now < d5){
        this.$emit('beginQuizQuestions', quizData.questions[4]);
      }
      else if (now >= d3 && now < d4){
        this.$emit('beginQuizQuestions', quizData.questions[3]);
      }
      else if (now >= d2 && now < d3){
        this.$emit('beginQuizQuestions', quizData.questions[2]);
      }
      else if (now >= d1 && now < d2){
        this.$emit('beginQuizQuestions', quizData.questions[1]);
      }
      else {
        this.$emit('beginQuizQuestions', quizData.questions[0]);
      }
      
  },
    WelcomeQuiz() {
      this.$emit('WelcomeQuiz');
    },
    showtheMenu() {
      this.$emit('UnlockMenu');
    },
    answerSelected(answerValue) {
      //this.$emit('beginQuizQuestions', quizData.questions[answerValue]);
      this.$emit('beginQuizQuestions', quizData.questions[answerValue]);
    }

  }
});



// WEBPACK FOOTER //
// ./src/EventBus.js